import { ViewModel,View, ObservableArray, ViewModelMessage, Binder } from "binder"
import { data } from "jquery";
import { BindingConverterResolver } from "src/binder/parser/prototype/bindingPrototype";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { DataModel } from "src/formBuilder/datamodel/structure";
import { Converters } from "../templateEditor/structureView/converters";
import { TemplateEditorViewModel } from "../templateEditor/templateEditor-viewModel";
import { MediaTypes, NoMediaTemplateViewModel, TemplateListViewModel, TemplateViewModel } from "../templateList/templateList-viewModel";
import { ViewModelBuilderViewModel } from "../viewModelBuilder/viewModelBuilder-viewModel";
import  { FormBuilderView } from "./formBuilder-view"

export class GetAllTemplateMessage extends ViewModelMessage{
    
}
export interface IFormBuilderPart{
    set partName(v: string);get partName(): string;
    
}
export class FormBuilderViewModel extends ViewModel implements IFormBuilderPart{
    
    private static isConvertersAdded :boolean = false;
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        
        if(FormBuilderViewModel.isConvertersAdded==false){
            FormBuilderViewModel.isConvertersAdded=true;
            BindingConverterResolver.converterRepository.push(new Converters());
        }
        this.partName = 'فرم ساز';
        this.editor = new TemplateEditorViewModel(this);
        this.dataModel = new DataModel(this);
        this.templateList = new TemplateListViewModel(this);
    }

    public getTypeId(): string {
        return '251F7ED5-C169-4B3F-BC02-E8766D2607E2';
    }
    public GetDefaultView(): View<ViewModel> {
        return new FormBuilderView();
    }
    
    public set templateList(v: TemplateListViewModel) { this._templateList = v; } public get templateList(): TemplateListViewModel { return this._templateList;} private _templateList: TemplateListViewModel;
    public set editor(v: TemplateEditorViewModel) { this._editor = v; } public get editor(): TemplateEditorViewModel { return this._editor;} private _editor: TemplateEditorViewModel;
    public set dataModel(v: DataModel) { this._dataModel = v; } public get dataModel(): DataModel { return this._dataModel;} private _dataModel: DataModel;
    public set partName(v: string) { this._partName = v; } public get partName(): string { return this._partName;} private _partName: string;
    
            

    editTemplate(template: TemplateViewModel,mediaType:MediaTypes) : Promise<boolean> {
        return this.editor.edit(template,null,mediaType)
    }
    
    override handleMessage(msg:ViewModelMessage){
        if(msg instanceof GetAllTemplateMessage){
            return [...this.templateList.templates];
        }else{
            return super.handleMessage(msg);
        }
    }

    serailize():any{
        return {
            Templates : this.templateList.templates.map(x=>{
                return {
                    Name : x.name,
                    ClassName : x.dataModelClass.name,
                    Json : x.jsonInfo,
                    Html : x.htmlContent,
                    IsMain : x.isMain,
                    IsDetail : x.isDetail,
                    MediaType : <number>x.mediaType
                };
            })
        }
    }

    deserialize(info:any){
        let templates : TemplateViewModel[] = info.Templates.map(x=>{
            let template = new TemplateViewModel(this.templateList);
            template.name = x.Name;
            template.dataModelClass = this.dataModel.classes.filter(y=>y.name==x.ClassName)[0];
            template.jsonInfo = x.Json;
            template.isMain = x.IsMain;
            template.isDetail = x.IsDetail;
            template.mediaType = x.MediaType ?? MediaTypes.default;
            template.updateTemplateHtml(x.Html);
            return template;
        });
        templates.forEach(x=>{
            let relatedNoMediaTemplate = this.templateList.noMediaTemplates.filter(y=>y.name==x.name).at(0);
            if(relatedNoMediaTemplate==null){
                relatedNoMediaTemplate = new NoMediaTemplateViewModel(this);
                relatedNoMediaTemplate.name = x.name;
                relatedNoMediaTemplate.dataModelClass = x.dataModelClass;
                relatedNoMediaTemplate.isMain = x.isMain;
                relatedNoMediaTemplate.isDetail = x.isDetail;
                this.templateList.noMediaTemplates.push(relatedNoMediaTemplate);
            }
            relatedNoMediaTemplate.templates.push(x);
        })
        this.templateList.templates.update(...templates);
    }

    updateModelFromJson(json){
        let dataModel = new DataModel(this);
        dataModel.Parse(json);
        dataModel.generateClasses(this,false);
        this.dataModel = dataModel;
    }
}

